module.exports = __webpack_public_path__ + "static/media/sidebar-3.df151f8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sidebar-3.jpg
// module id = 1451
// module chunks = 0